import { Box, Card, CardContent, Typography } from "@mui/material";
import { COLORS } from "../../ui/Theme";
import SubscriptionCardFeatures from "./SubscriptionCardFeatures";


const SubscriptionCard = ({ info, getInfoHandler, plan_name }) => {

    // set state the information of selected card + add the plan name of it
    const handleSelectedCardInfo = () => {
        getInfoHandler({ ...info, plan_name })
    }

    info.discount_percent = 10
    return (
        <Card
            sx={{
                bgcolor: COLORS.WHITE,
                boxShadow: "0px 10px 15px -3px rgba(0,0,0,0.2)",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: 1,
                width: "300px",
                borderRadius: 8,
                position: "relative",
            }}>
            <Typography sx={{
                fontSize: info.has_discount ? "16px" : "22px",
                color: info.has_discount && COLORS.GRAY,
                textDecoration: info.has_discount && "line-through",
                bgcolor: COLORS.BLUE,
                color: COLORS.WHITE,
                width: "100%",
                px: 2,
                py: 4,
                fontWeight: 600,
                textAlign: "center",
                borderRadius: 4
            }}>
                {info.discounted_price.toLocaleString("fa-IR")} تومان
            </Typography>

            {!info.has_discount && (
                <Typography sx={{
                    position: "absolute",
                    right: -60,
                    top: 10,
                    px: 4,
                    py: 1,
                    bgcolor: COLORS.ORANGE,
                    width: 200,
                    transform: "rotate(-40deg)",
                    textAlign: "center",
                    fontSize: 12,
                    fontWeight: 600,
                    color: COLORS.BLACK

                }}>
                    {info.discount_percent + "%" + " " + "تخفیف"}
                </Typography>
            )}

            <Box sx={{
                bgcolor: COLORS.SOFTBLUE,
                width: "100%",
                p: 2,
                borderRadius: 4,
            }}>
                <Typography sx={{
                    textAlign: "center",
                    fontSize: 24,
                    fontWeight: "bold",
                    color: COLORS.BLUE
                }}>
                    {info.duration}
                </Typography>
            </Box>

            <Box sx={{
                bgcolor: COLORS.SOFTGRAY,
                width: "100%",
                p: 2,
                borderRadius: 4,
            }}>
                {/*duration*/}


                {/*features*/}
                <SubscriptionCardFeatures />
            </Box>

            <button onClick={handleSelectedCardInfo} className="btn btn-blue" style={{ borderRadius: "32px" }}>خرید</button>

        </Card >
    );
};

export default SubscriptionCard;